<template>
    <div>
        <div class="agencyCentre-wrapper teamIncomeOverview-screen" style="background-color: #F2F2F2;">
            <div class="position-relative items-center agencyCentre-headerBar bg-white">
                <div class="angle black-angle" id="close" @click="viewClose('someStatus')"></div>
                <div class="text-center agencyCentre-headerHD">Trade Account</div>
                <router-link class="goTransactionHistory-btn" @click="goToTransactionHistory()" :to="{
                    name: 'TradeAccount',
                    query: {
                        timestamp: '2023080201',
                        cversion: '2025052031',
                        language: 'en',
                        channel: 307,
                        apptype: 32,
                        jsbSwitch: 1,
                        curDomain: 'nchamet.com',
                        userid: 16650822,
                        token
                    }
                }">
                    <img :src='goTransactionHistoryIcon' alt="" />
                </router-link>
            </div>
            <div class="p-2">
                <div class="tradeMain-wrapper">
                    <div class="p-2 pb-2 bg-white tradeAcc-statusCard">
                        <div class="d-flex justify-content-between align-items-start">
                            <div class="tradeAcc-statusLeft-box">
                                <div class="mb-2 statusType-title">My Stats - Last Week</div>
                                <div class="py-2 px-3 statusType-infoBox">
                                    <div class="d-flex align-items-center gap-2">
                                        <div>Bal :</div>
                                        <div class="d-flex align-items-center gap-1">
                                            <img :src='diamondIcon' class="diamondIcon" alt="" />
                                            <span class="diamond-val">{{ getTradeAccountData.total_points }}</span>
                                        </div>
                                    </div>
                                    <div># {{ spendCoinsTradeAccountData.total_count }} Transactions</div>
                                    <div># {{ spendCoinsTradeAccountData.total_point }}</div>
                                    <div class="d-flex align-items-center">
                                        <svg class="inr-currencyIcon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
                                            <path
                                                d="M.0022 64C.0022 46.33 14.33 32 32 32H288C305.7 32 320 46.33 320 64C320 81.67 305.7 96 288 96H231.8C241.4 110.4 248.5 126.6 252.4 144H288C305.7 144 320 158.3 320 176C320 193.7 305.7 208 288 208H252.4C239.2 266.3 190.5 311.2 130.3 318.9L274.6 421.1C288.1 432.2 292.3 452.2 282 466.6C271.8 480.1 251.8 484.3 237.4 474L13.4 314C2.083 305.1-2.716 291.5 1.529 278.2C5.774 264.1 18.09 256 32 256H112C144.8 256 173 236.3 185.3 208H32C14.33 208 .0022 193.7 .0022 176C.0022 158.3 14.33 144 32 144H185.3C173 115.7 144.8 96 112 96H32C14.33 96 .0022 81.67 .0022 64V64z" />
                                        </svg>
                                        <!-- <img :src='diamondIcon' class="diamondIcon" alt="" /> -->
                                        <span>{{ spendCoinsTradeAccountData.total_amount }}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="tradeAcc-statusRight-box">
                                <div class="mb-2 weekdays-dropBox"
                                    :style="{ backgroundImage: `url(${down_arrowIcon})` }" @click="openDateModal"> {{
                                        selectedDateRange }}
                                </div>
                                <div
                                    class="d-flex justify-content-center align-items-center m-auto fw-bold fst-italic text-white trade-perBox">
                                    {{ tradeRatio }}</div>
                                <div class="trade-btn payoutBtn mt-3"
                                    v-if="this.checkTradeAccountStatus?.enabled_payout === 1"
                                    @click="goToPayoutHistory()">Payout</div>
                            </div>
                        </div>
                    </div>
                    <div class="mt-2 p-2 pb-4 bg-white tradeAcc-formCard">
                        <div class="">
                            <div class="mb-2 trade-formGroup">
                                <label class="mb-1 trade-label">Transfer To</label>
                                <input type="tel" class="trade-formControl" placeholder="User ID"
                                    v-model.trim="form.userId" @input="onlyDigits('userId', $event);
                                    clearIfValid('userId')" @blur="showRequired('userId')" inputmode="numeric"
                                    pattern="\d*" enterkeyhint="next" autocomplete="off" />
                                <div class="text-danger error" v-if="errors.userId">{{ errors.userId }}</div>
                            </div>
                            <div class="mb-2 trade-formGroup">
                                <label class="mb-1 trade-label">Enter Point</label>
                                <!-- <input type="text" class="trade-formControl" placeholder="Points" v-model.trim="form.points" @input="onlyDigits('points', $event); clearIfValid('points')" @blur="showRequired('points')" inputmode="numeric" pattern="[0-9]*"/> -->
                                <input type="tel" class="trade-formControl" placeholder="Points"
                                    v-model.trim="form.points" @input="onlyDigits('points', $event);
                                    clearIfValid('points')" @blur="showRequired('points')" inputmode="numeric"
                                    pattern="\d*" enterkeyhint="next" autocomplete="off" />
                                <div class="text-danger error" v-if="errors.points">{{ errors.points }}</div>
                            </div>
                            <div class="mb-2 trade-formGroup">
                                <label class="mb-1 trade-label">Enter Amount</label>
                                <!-- <input type="text" class="trade-formControl" placeholder="Amount" v-model.trim="form.amount" @input="onlyDigits('amount', $event);  clearIfValid('amount')"  @blur="showRequired('amount')" inputmode="numeric" pattern="[0-9]*"/> -->
                                <!-- <input
                                type="text"
                                class="trade-formControl"
                                placeholder="Amount"
                                v-model.trim="form.amount"
                                @keydown="allowDecimalKey('amount', $event)"
                                @input="onlyDecimal('amount', $event, 2); clearIfValid('amount')"
                                @blur="showRequired('amount')"
                                inputmode="decimal"
                                pattern="^\d*\.?\d{0,2}$"
                                maxlength="10"  
                                /> -->
                                <input type="text" class="trade-formControl" placeholder="Amount"
                                    v-model.trim="form.amount" @keydown="allowDecimalKey('amount', $event)"
                                    @input="onlyDecimal('amount', $event, 2); clearIfValid('amount')"
                                    @blur="showRequired('amount')" inputmode="decimal" enterkeyhint="done"
                                    pattern="^\d*\.?\d{0,2}$" maxlength="10" />
                                <div class="text-danger error" v-if="errors.amount">{{ errors.amount }}</div>
                            </div>
                            <div class="mb-2 trade-formGroup">
                                <label class="mb-2 trade-label">To His/Her</label>
                                <div class="d-flex align-items-center gap-2">
                                    <img :src='pinkCircleCheckIcon' class="pinkCircleCheck-icon" alt="" />
                                    <span class="fw-semibold">Balance</span>
                                </div>
                            </div>
                            <div class="mb-2 tradeForm-bottomTile">(Balance is only used for consumption)</div>
                            <div class="trade-note">After transfer the user will receive diamonds ready to Activate.
                                After
                                you activate them diamonds will be Sent successfully</div>
                            <div class="px-3 trade-submitBtn-box">
                                <button type="button" class="trade-btn" @click="validateForm">Transfer</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Trade confirm popup -->
        <div class="mode-area" v-show="isPopupOverlayVisible"></div>
        <div id="rulesPopup"
            :class="{ 'bg-white tradeConfirm_popup popup_box': true, 'rule-pop-up': true, 'transform-in': rulesPopupVisible, 'transform-out': !rulesPopupVisible }">
            <div class="mb-3 text-center fw-semibold rulePopup-topHD">Confirmation</div>
            <div>
                <ul class="mb-4">
                    <li>User Name : {{ tradingUserName || 'N/A' }}</li>
                    <li>User ID : {{ form.userId }}</li>
                    <li>Diamond Amount : {{ form.points }}</li>
                    <li>Amount : ₹{{ form.amount }}</li>
                </ul>
            </div>
            <div class="d-flex justify-content-center align-items-center gap-2 confirm-popupBtn">
                <button type="button" class="trade-btn" @click="showRulesPopup">Cancel</button>
                <button type="button" class="trade-btn trade-primary-btn" @click="submitForm"
                    :disabled="loading || !!serverError">
                    {{ loading ? "Processing..." : "Confirm" }}
                </button>
            </div>
            <!-- NEW: server error message -->
            <div v-if="serverError" class="text-center text-danger mb-2 mt-2">
                {{ serverError }}
            </div>
        </div>

        <!-- Weekly Date popup -->
        <div class="dateSelectionModal" :style="showModal ? { bottom: '0' } : {}" v-if="showModal" @click="closeModal">
            <div class="dateSelectionModal-body" :style="{ bottom: '0' }" @click.stop>
                <div class="text-center text-white dateSelection-HD" style="background-color: #FF569E;">Select Date
                    Range</div>
                <ul class="filterOptions-list">
                    <li v-for="option in dateOptions" :key="option"
                        class="d-flex justify-content-center align-items-center gap-2 filterOptions-box"
                        :class="{ 'active-filterOptions': selectedDateRange === option }"
                        @click="selectDateRange(option)">
                        <div class="numberOf-week">{{ option }}</div>
                    </li>
                </ul>
            </div>
        </div>

        <div class="dateSelectionModal" :style="showCustomDateModal ? { bottom: '0' } : {}" v-if="showCustomDateModal"
            @click="closeCustomDateModal">
            <div class="pb-0 dateSelectionModal-body" :style="{ bottom: '0' }" @click.stop>
                <TradeCustomRangeCalendar :onCloseCustomDate="closeCustomDateModal" @apply-range="applyCustomRange" />
            </div>
        </div>

    </div>
</template>
<script>
import './TradeAccount.css';
import diamondIcon from '../../assets/images/diamond-icon.png';
import down_arrowIcon from '../../assets/images/down_arrowIcon.png';
import pinkCircleCheckIcon from '../../assets/images/pink-circleCheck-icon.svg';
import goTransactionHistoryIcon from '../../assets/images/go-transactionHistory-icon.svg';
import TradeCustomRangeCalendar from './TradeCustomRangeCalendar.vue'
import axios from "axios";


export default {
    name: 'TradeAccount',
    components: {
        TradeCustomRangeCalendar
    },
    data() {
        return {
            diamondIcon,
            down_arrowIcon,
            pinkCircleCheckIcon,
            goTransactionHistoryIcon,
            form: {
                userId: "",
                points: "",
                amount: "",
            },
            props: {
                timestamp: String,
                cversion: String,
                language: String,
                channel: Number,
                apptype: Number,
                jsbSwitch: Number,
                curDomain: String,
                userid: Number,
            },
            tradingUserName: '',
            tradingNameCache: {},
            errors: {},
            loading: false,
            checkTradeAccountStatus: null,
            // spendCoinsTradeAccountData: null,
            getTradeAccountData: { total_points: 0 },
            spendCoinsTradeAccountData: { total_count: 0, total_amount: 0, total_point: 0 },
            apiResponse: null,
            tradeRatio: "0.00",
            selectedDateRange: "Today",
            dateOptions: ["Today", "Yesterday", "Last 7 Days", "1 Month", "Custom Dates"],
            showModal: false,
            rulesPopupVisible: false,
            isPopupOverlayVisible: false,
            showCustomDateModal: false,

            // route/auth
            token: '',
            serverError: '',
        };
    },
    mounted() {
        this.token = String((this.$route.query.token ?? this.$route.params.token ?? '')).trim()
        sessionStorage.setItem("tradeAcountToken", this.token)
        this.fetchTradeAccountData();
        this.fetchSpendCoinsTradeaccount();
    },
    methods: {
        // allow 0-9 and one "."; limit decimals (default 2)
        // onlyDecimal(field, e, maxDecimals = 2) {
        //     let v = String(e?.target?.value ?? '');

        //     // keep digits and dots
        //     v = v.replace(/[^\d.]/g, '');
        //     // keep only first dot
        //     v = v.replace(/(\..*)\./g, '$1');
        //     // ".5" -> "0.5"
        //     if (v.startsWith('.')) v = '0' + v;

        //     // limit decimal places
        //     if (maxDecimals >= 0 && v.includes('.')) {
        //     const [i, d = ''] = v.split('.');
        //     v = i + '.' + d.slice(0, maxDecimals);
        //     }

        //     if (e && v !== e.target.value) e.target.value = v;
        //     this.form[field] = v;
        // },      


        onlyDecimal(field, e, maxDecimals = 2) {
            let v = String(e?.target?.value ?? '');
            v = v.replace(',', '.');         // NEW: normalize comma to dot
            v = v.replace(/[^\d.]/g, '');    // keep digits and dots
            v = v.replace(/(\..*)\./g, '$1');// only first dot
            if (v.startsWith('.')) v = '0' + v;
            if (maxDecimals >= 0 && v.includes('.')) {
                const [i, d = ''] = v.split('.');
                v = i + '.' + d.slice(0, maxDecimals);
            }
            if (e && v !== e.target.value) e.target.value = v;
            this.form[field] = v;
        },


        // block invalid keys early (keeps arrows, backspace, tab, etc.)
        allowDecimalKey(field, e) {
            const keep = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab', 'Home', 'End'];
            if (keep.includes(e.key) || (e.ctrlKey || e.metaKey)) return;
            if (e.key === '.') {
                if ((this.form[field] || '').includes('.')) e.preventDefault();
                return;
            }
            if (!/^\d$/.test(e.key)) e.preventDefault();
        },
        clearIfValid(field) {
            const v = String(this.form[field] ?? '').trim();
            if (field === 'userId') {
                if (/^\d+$/.test(v)) delete this.errors.userId;
            } else if (field === 'points') {
                if (/^\d+(\.\d{1,2})?$/.test(v)) delete this.errors.points;
            } else if (field === 'amount') {
                const decOk = /^\d+(\.\d{1,2})?$/.test(v);
                const n = parseFloat(v);
                const available = Number(this.getTradeAccountData?.total_points || 0);
                if (decOk && n >= 200 && n <= available) delete this.errors.amount;
            }
        },
        showRequired(field) {
            const labels = { userId: 'User ID', points: 'Points', amount: 'Amount' };
            const v = String(this.form[field] ?? '').trim();
            if (!v) {
                this.errors[field] = `${labels[field]} is required!`;
            }
        },
        onlyDigits(field, e) {
            const cleaned = String(e?.target?.value ?? '').replace(/\D+/g, '');
            if (e && cleaned !== e.target.value) e.target.value = cleaned;
            this.form[field] = cleaned;
        },
        async validateForm() {
            this.errors = {};

            // normalize/trim
            const userIdStr = String(this.form.userId ?? '').trim();
            const pointsStr = String(this.form.points ?? '').trim();
            const amountStr = String(this.form.amount ?? '').trim();
            const digitsOnly = /^\d+$/;

            // USER ID
            if (!userIdStr) {
                this.errors.userId = 'User ID is required!';
            } else if (!digitsOnly.test(userIdStr)) {
                this.errors.userId = 'Please enter a valid user id';
            }

            if (!pointsStr) {
                this.errors.points = 'Points is required!';
            } else if (!digitsOnly.test(pointsStr)) {
                this.errors.points = 'Please enter a valid points';
            }
            // POINTS (allow decimals)
            // if (!pointsStr) {
            // this.errors.points = 'Points is required!';
            // } else if (!/^\d+(\.\d{1,2})?$/.test(pointsStr)) {
            // this.errors.points = 'Please enter valid points (up to 2 decimals)';
            // }

            // AMOUNT (allow decimals)
            const available = Number(this.getTradeAccountData?.total_points || 0);
            if (!amountStr) {
                this.errors.amount = 'Amount is required!';
            } else if (!/^\d+(\.\d{1,2})?$/.test(amountStr)) {
                this.errors.amount = 'Please enter a valid amount (up to 2 decimals)';
            } else {
                const amountNum = parseFloat(amountStr);
                if (amountNum < 200) {
                    this.errors.amount = 'Amount must be greater than 199';
                } else if (amountNum > available) {
                    this.errors.amount = 'Please enter an amount within your available balance.';
                }
            }

            // stop on errors
            if (Object.keys(this.errors).length) return;

            // write normalized values back (optional)
            this.form.userId = userIdStr;
            this.form.points = String(Number(pointsStr));
            this.form.amount = String(Number(amountStr));

            // proceed
            await this.fetchTradingUserName(this.form.userId);
            this.showRulesPopup();
        },
        resetForm() {
            this.form = { userId: "", points: "", amount: "" };
            this.errors = {};
            this.apiResponse = null;
        },
        async fetchSpendCoinsTradeaccount(startDate = "", endDate = "") {
            try {
                const { data } = await axios.get("api/spend-coins-tradeaccount", {
                    headers: { Accept: "application/json", Authorization: `Bearer ${this.token}` },
                    params: { start_date: startDate, end_date: endDate }
                });

                const r = data?.result || {};
                this.spendCoinsTradeAccountData = {
                    total_count: Number(r.total_count) || 0,
                    total_amount: Number(r.total_amount) || 0,
                    total_point: Number(r.total_point) || 0
                };

                // ratio
                const tAmt = this.spendCoinsTradeAccountData.total_amount;
                const pts = this.spendCoinsTradeAccountData.total_point;
                this.tradeRatio = (tAmt >= 1 && pts >= 1) ? (pts / tAmt).toFixed(2) : "0.00";
            } catch (e) {
                console.error("API Error:", e);
                this.spendCoinsTradeAccountData = { total_count: 0, total_amount: 0, total_point: 0 };
                this.tradeRatio = "0.00";
            }
        },
        selectDateRange(option) {
            this.selectedDateRange = option;
            this.showModal = false
            const today = new Date();
            let startDate = "";
            let endDate = "";
            if (option === "Today") {
                startDate = this.formatDate(today);
                endDate = this.formatDate(today);
            } else if (option === "Yesterday") {
                const yesterday = new Date(today);
                yesterday.setDate(today.getDate() - 1);
                startDate = this.formatDate(yesterday);
                endDate = this.formatDate(yesterday);
            } else if (option === "Last 7 Days") {
                const lastWeek = new Date(today);
                lastWeek.setDate(today.getDate() - 6);
                startDate = this.formatDate(lastWeek);
                endDate = this.formatDate(today);
            } else if (option === "1 Month") {
                const lastMonth = new Date(today);
                lastMonth.setMonth(today.getMonth() - 1);
                startDate = this.formatDate(lastMonth);
                endDate = this.formatDate(today);
            } else if (option === "Custom Dates") {
                this.openCustomDateModal();
                return;
            }
            this.fetchSpendCoinsTradeaccount(startDate, endDate);
        },
        applyCustomRange({ start, end, display }) {
            this.selectedDateRange = display || `${this.formatDisplayDateStr(start)} → ${this.formatDisplayDateStr(end)}`;
            this.closeCustomDateModal();
            this.fetchSpendCoinsTradeaccount(start, end);
        },

        // helper to pretty-print 'YYYY-MM-DD' for the label (e.g., 22 Aug 2025)
        formatDisplayDateStr(ymd) {
            try {
                const [y, m, d] = ymd.split("-");
                return new Date(+y, +m - 1, +d).toLocaleDateString("en-GB", {
                    day: "2-digit",
                    month: "short",
                    year: "numeric",
                });
            } catch {
                return ymd;
            }
        },
        async fetchTradeAccountData() {
            try {
                const { data } = await axios.get('api/getTradeAccount', {
                    headers: { Accept: 'application/json', Authorization: `Bearer ${this.token}` }
                });

                const r = data?.result || {};
                this.getTradeAccountData = {
                    total_points: Number(r.total_points) || 0
                };
                this.checkTradeAccountStatus = r
            } catch (error) {
                console.error('API Error:', error);
                this.getTradeAccountData = { total_points: 0 };
            }
        },
        async fetchTradingUserName(userId) {
            if (!userId) { this.tradingUserName = ''; return; }
            if (this.tradingNameCache[userId]) {
                this.tradingUserName = this.tradingNameCache[userId];
                return;
            }

            this.tradingUserNameLoading = true;
            this.tradingUserName = '';

            try {
                const res = await axios.post('api/getnametradeaccount',
                    { profile_id: userId },
                    {
                        headers: {
                            Accept: 'application/json',
                            Authorization: `Bearer  ${this.token}`,
                        },
                    }
                );

                // map defensively to name
                const name =
                    res?.data?.result?.name ??
                    res?.data?.data?.name ??
                    res?.data?.name ??
                    '';

                this.tradingUserName = name || 'N/A';
                this.tradingNameCache[userId] = this.tradingUserName;
            } catch (e) {
                console.error('getnametradeaccount error:', e);
                this.tradingUserName = 'N/A';
            } finally {
                this.tradingUserNameLoading = false;
            }
        },
        async submitForm() {
            this.loading = true;
            this.serverError = '';
            this.apiResponse = null;
            try {
                const res = await axios.post("api/sendtransferTradeAccount",
                    {
                        profile_id: this.form.userId,
                        amount: this.form.points,
                        actual_amount: this.form.amount,
                        type: '1'
                    },
                    {
                        headers: {
                            Accept: "application/json",
                            Authorization: `Bearer  ${this.token}`
                        },
                    }
                );

                this.apiResponse = res.data;
                this.resetForm();
                this.fetchTradeAccountData();
                this.fetchSpendCoinsTradeaccount();
                this.showRulesPopup();
                this.$router.replace('/trade/transection-history');

            } catch (err) {
                this.serverError = err.response?.data.error
            } finally {
                this.loading = false;
            }
        },
        showRulesPopup() {
            this.serverError = ''
            this.rulesPopupVisible = !this.rulesPopupVisible
            this.isPopupOverlayVisible = !this.isPopupOverlayVisible;
        },
        openDateModal() {
            this.showModal = true;
        },
        closeModal() {
            this.showModal = false;
        },
        openCustomDateModal() {
            this.showCustomDateModal = true;
            this.showModal = false;
        },
        closeCustomDateModal() {
            this.showCustomDateModal = false;
        },
        goToTransactionHistory() {
            this.$router.push(`/trade/transection-history`);
        },

        goToPayoutHistory() {
            this.$router.push(`/trade/payout-history`);
        },

        viewClose(status) {
            if (window.Android && typeof Android.viewClose === "function") {
                Android.viewClose(status);
            } else {
                window.parent.postMessage({ action: "closePopup", status }, "*");
            }
        },
        // Utility function for formatting dates to YYYY-MM-DD
        formatDate(date) {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, "0");
            const day = String(date.getDate()).padStart(2, "0");
            return `${year}-${month}-${day}`;
        },
    }
}

</script>